export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const mediaUrl = (u) => (u.startsWith("http") ? u : `${BACKEND_URL}${u}`);
export const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const inputClass =
  "w-full rounded-xl border border-brand/20 bg-white px-4 py-3.5 text-sm text-forest placeholder:text-brand/40 outline-none transition-all duration-300 focus:border-gold focus:ring-4 focus:ring-gold/10";
export const labelClass = "mb-2 block font-mono text-[11px] uppercase tracking-[0.2em] text-brand";
export const fileClass =
  "w-full rounded-xl border-2 border-dashed border-brand/30 bg-white px-4 py-3 text-sm text-forest file:mr-3 file:rounded-full file:border-0 file:bg-brand file:px-3 file:py-1.5 file:font-mono file:text-xs file:uppercase file:text-white";
export const primaryBtn =
  "flex items-center gap-3 rounded-full bg-gold px-6 py-3.5 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-white shadow-lg shadow-gold/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold-hover disabled:opacity-60";
export const ghostBtn =
  "inline-flex items-center gap-2 rounded-full border border-brand/30 px-4 py-2 font-mono text-[11px] uppercase tracking-widest text-brand transition-colors hover:bg-mint";

export const handleAuthError = (err, logout, fallback) => {
  if (err.response?.status === 401) {
    logout();
  } else {
    fallback();
  }
};

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
